import {Component, ChangeDetectionStrategy} from '@angular/core';

/**
 * An empty component for use within SPA
 */
@Component({
  selector: 'app-hidden',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HiddenComponent {}
